import { useNavigate } from 'react-router-dom';
import { ItemForm } from '../components/ItemForm';
import { useCreateFoundItem } from '../hooks/useFoundItems';

export function NewItemPage() {
	const navigate = useNavigate();
	const createMutation = useCreateFoundItem();

	return (
		<div className="min-h-screen bg-gray-50">
			<header className="sticky top-0 z-30 bg-white border-b border-gray-200">
				<div className="max-w-4xl mx-auto px-4 h-16 flex items-center justify-between">
					<h1 className="text-lg font-semibold text-gray-900">Novo Item</h1>
				</div>
			</header>
			<main className="max-w-2xl mx-auto px-4 py-8">
				<div className="bg-white border border-gray-200 rounded-lg p-6">
					<ItemForm
						onSubmit={(data) => {
							createMutation.mutate(
								{
									title: data.title,
									description: data.description || null,
									categoryId: data.categoryId,
									photoUrl: data.photoUrl,
									foundLocationText: data.foundLocationText,
									foundLatitude: data.foundLatitude ? Number(data.foundLatitude) : null,
									foundLongitude: data.foundLongitude ? Number(data.foundLongitude) : null,
								},
								{
									onSuccess: (created) => navigate(`/items/${created.id}`),
								},
							);
						}}
						isPending={createMutation.isPending}
						submitLabel="Criar item"
					/>
				</div>
			</main>
		</div>
	);
}
